module.exports = __webpack_public_path__ + "static/media/coin.7ef64218.gif";